<template>
  <div>
    <Header title="Ajuda e Suporte" subtitle="Dúvidas ou problemas ao jogar?"></Header>
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="toc-section">
            <h5>Tópicos</h5>
            <ul>
              <li>
                <a href="#anticheater">Anticheater</a>
              </li>
              <!-- <li>
                <a href="#nivelamento">Nivelamento / Rankings</a>
              </li>

              <li>
                <a href="#ranked-lobbies">Ranked e Lobbies</a>
              </li> -->
              <!-- <li>
                <a href="#notificacoes">Notificações</a>
              </li> -->
              <!-- <li>
                <a href="#perfil">Perfil</a>
              </li>
              <li>
                <a href="#creditos">Créditos</a>
              </li> -->
              <!-- <li>
                <a href="#times">Times</a>
              </li>
              <li>
                <a href="#campeonatos">Campeonatos</a>
              </li>
              <li>
                <a href="#admin-campeonatos">Administração de Campeonatos</a>
              </li> -->
            </ul>
          </div>

          <a name="anticheater"></a>
          <div class="faq-section">
            <h2>Anticheater</h2>

            <dl>
              <dt>Qual anticheater usado no QUEOTA.club?</dt>
              <dd>Usamos nosso próprio anticheat, além é claro de VAC em nossos servidores.</dd>

              <dt>Onde faço o download do anticheater?</dt>
              <dd>
                <a href="/ac/QUEOTA.club.exe">Clique aqui para baixar, pelo nosso site.</a>
              </dd>

              <dt>Como usar o anticheater?</dt>
              <dd>Abra o anticheater, faça login com seu email e senha</dd>
              <dd>Abra o jogo e conecte no servidor.</dd>

              <dt>Problemas ao abrir o anticheater? (.Net)</dt>
              <dd><a href="https://www.microsoft.com/pt-br/download/details.aspx?id=49982" target="_blank">Baixe e instale este programa</a> e então reabra o anticheater.</dd>
            </dl>
          </div>

          <!-- <a name="nivelamento"></a>
          <div class="faq-section">
            <h2>Rankings e Nivelamento</h2>

            <dl>
              <dt>Como funciona o nível/patente aqui no QUEOTA.club?</dt>
              <dd>Nosso rankeamento hoje funciona do nível A ao nível E, sendo A com a melhor performance e E sendo a pior performance</dd>

              <dt>Quanto tempo demora para eu ter meu ranking?</dt>
              <dd>Você precisa jogar 7 partidas 5x5, seja em campeonatos, seja em lobbies ou em nossa ranked.</dd>

              <dt>Como vocês equilibram os times na Ranked?</dt>
              <dd>Garantimos que os melhores jogadores buscando partida sejam equilibrados por igual em ambos os times, no padrão Round Robin.</dd>
            </dl>
          </div> -->
<!--
          <a name="ranked-lobbies"></a>
          <div class="faq-section">
            <h2>Ranked e Lobbies</h2>

            <dl>
              <dt>Como faço para jogar na QUEOTA.club?</dt>
              <dd>Nosso rankeamento hoje funciona do nível A ao nível E, sendo A com a melhor performance e E sendo a pior performance</dd>

              <dt>O que são RANKED e Lobbies?</dt>
              <dd>
                Ranked você irá jogar com 10 jogadores nivelados por nós, distribuindo os 10 aleatoriamente num competitivo 5x5.
                <br>A lobby quem comanda é você, você pode criar desde o 1x1 até o 5x5, podendo escolher mapa, nome dos times, quem irá jogar e passar o link para os amigos além da lobby ficar aberta para o público.
                <br>Quer entender um pouco melhor?
                <a
                  href="https://queota.club/blogposts/genesis-boas-vindas-queota-club"
                >Clique aqui</a>.
              </dd>
            </dl>
          </div> -->

          <!-- <a name="notificacoes"></a>
          <div class="faq-section">
            <h2>Notificações</h2>

            <dl>
              <dt>Onde recebo notificações?</dt>
              <dd>As notificações aparecerão todas em seu inbox do lado do nome do perfil.</dd>

              <dt>O que é inbox?</dt>
              <dd>Inbox é uma aba específica para notificações da plataforma.</dd>

              <dt>Como saberei se há alguma notificação?</dt>
              <dd>Aparecerá um alerta no canto superior direito da tela, avisando que você tem uma nova notificação. Caso você não veja, o contador de notificações estará te avisando em ordem crescente a quantidade de notificações recebidas, quando tiver visualizado todas, terá 0 mensagens na inbox.</dd>

              <dt>Quais notificações irei receber?</dt>
              <dd>Por enquanto irá receber agendamento de partida contra seu time e notificação de replay de partida, nosso recurso exclusivo no cenário.</dd>
            </dl>
          </div> -->
<!--
          <a name="perfil"></a>
          <div class="faq-section">
            <h2>Perfil</h2>

            <dl>
              <dt>Onde vejo meu perfil?</dt>
              <dd>No canto superior direito do site há o seu usuário com nome, por exemplo: ADM QUEOTA.club. Clicando no seu nome, aparecerá a opção “Meu Perfil”. Você encontrará todas as informações do seu perfil, gráficos sobre sua ranked, medalhas, partidas agendadas e times aos quais pertence.</dd>

              <dt>Como edito minha foto de capa e de perfil?</dt>
              <dd>Na página do seu perfil, você pode alterar ambos passando o mouse na sua foto de perfil, terão duas opções “Alterar Avatar” para mudar a sua foto que irá aparecer no site e “Alterar Cover” para mudar a foto de capa no site.</dd>

              <dt>Como edito meu nome e dados presentes no perfil?</dt>
              <dd>Logo embaixo da sua foto de perfil, há uma opção chamada “editar perfil”. Clicando nessa opção você poderá alterar todos os dados.</dd>
            </dl>
          </div> -->

          <!-- <a name="creditos"></a>
          <div class="faq-section">
            <h2>Créditos</h2>

            <dl>
              <dt>Para que servem os créditos?</dt>
              <dd>Crédito é a quantia de dinheiro presente na sua conta da QUEOTA.club para pagamento no site em transações envolvendo dinheiro.</dd>

              <dt>Onde se encontra a opção de créditos?</dt>
              <dd>Clicando no seu perfil, no canto direito superior da tela, aparecerá opção Créditos</dd>

              <dt>Como posso usar os créditos?</dt>
              <dd>Você poderá usar seus créditos para efetuar pagamento da conta premium, pagamento de campeonatos para seu time e de produtos dentro do nosso site.</dd>

              <dt>Como colocar créditos?</dt>
              <dd>Dentro da página de créditos, há uma opção ADICIONAR CRÉDITOS. Clicando nessa opção irá abrir a página para depósito de créditos, podendo escolher a quantia e a forma de pagamento.</dd>

              <dt>Como vejo meu saldo?</dt>
              <dd>Na página de créditos aparecerá automaticamente seu saldo em MEU SALDO.</dd>

              <dt>Histórico de transações?</dt>
              <dd>Todas as quantidades de crédito depositadas, retiradas ou usadas dentro da plataforma estarão em seu histórico para que o cliente tenha sempre todas as informações de quanto gastou.</dd>
            </dl>
          </div> -->
<!--
          <a name="times"></a>
          <div class="faq-section">
            <h2>Times</h2>

            <dl>
              <dt>Como cadastro meu time?</dt>
              <dd>
                Clicando em times, você irá para a página de times da plataforma, clique em
                <router-link :to="{ name: 'TeamCreate' }">Criar um time</router-link>. Complete todos os dados, crie uma senha e pronto.
              </dd>

              <dt>Como achar um time?</dt>
              <dd>
                Na
                <router-link :to="{ name: 'TeamList' }">página de times</router-link>você pode procurar o nome do time na barra de pesquisa.
              </dd>

              <dt>Como entro no time?</dt>
              <dd>Dentro do perfil do time, clique em Entrar no time e digite a senha. Pronto, você já é membro do time.</dd>

              <dt>Tem limite de jogadores?</dt>
              <dd>Não</dd>

              <dt>Não achei opção para coach, o que fazer?</dt>
              <dd>O coach será definido dentro do servidor, quando ele entrar e digitar !coach, ele será automaticamente colocado em coach spec do time pertencente.</dd>
            </dl>
          </div> -->
<!--
          <a name="campeonatos"></a>
          <div class="faq-section">
            <h2>Campeonatos</h2>

            <dl>
              <dt>Posso participar de qualquer campeonato?</dt>
              <dd>Depende do organizador, tem campeonatos abertos e tem campeonatos fechados. Sempre é bom ficar atento na aba campeonatos, ler o regulamento e ver os valores.</dd>

              <dt>Vocês tem campeonatos?</dt>
              <dd>Temos sim, fique atento sempre nas novidades que postamos no blog, fórum e na aba de campeonatos.</dd>

              <dt>Como me inscrevo no campeonato?</dt>
              <dd>Depois de ler o regulamento e estiver de acordo. Monte seu time, mostramos como fazer no tópico “times” logo acima. Pelo menos um dos membros do time precisarão estar com os créditos necessários para participar do campeonato em saldo na QUEOTA.club. Tendo os créditos, basta clicar em QUERO INSCREVER MEU TIME, selecionar seu time e pronto.</dd>

              <dt>Quero fazer meu campeonato, como entrar em contato?</dt>
              <dd>Entre na página de campeonatos, clique em criar um campeonato e preencha os dados. Entraremos em contato.</dd>
            </dl>
          </div>

          <a name="admin-campeonatos"></a>
          <div class="faq-section">
            <h2>Administração de Campeonatos</h2>

            <dl>
              <dt>Como coloco a imagem de capa do meu campeonato?</dt>
              <dd>No espaço para a imagem de capa, no canto inferior direito, há uma opção “alterar cover”.</dd>

              <dt>Qual o formato para imagem de capa de meu campeonato?</dt>
              <dd>
                Tamanho ideal 1980x500. Oferecemos um modelo/template para Photoshop para melhor aproveitamento do espaço.
                <a
                  href="/support/template-cover-campeonato.psd.zip"
                >Baixe aqui</a>
              </dd>

              <dt>Quem vai adicionar os times no campeonato?</dt>
              <dd>
                Nós da QUEOTA.club iremos adicionar os times manualmente dentro do campeonato. A organização irá comunicar os times e iremos colocá-los no campeonato.
                <br>Caso os pagamentos sejam feitos pelo site da QUEOTA.club, os próprios times irão usar os créditos e entrar no campeonato.
              </dd>

              <dt>Como terei acesso para configurar a página do campeonato?</dt>
              <dd>Iremos dar ADMIN para os responsáveis pelo campeonato e somente estes terão acesso a configurações dentro da página.</dd>

              <dt>Sobre os times inscritos:</dt>
              <dd>
                Os times devem ter TODOS os players cadastrados antes do agendamento da partida, tanto complete e coach.
                <br>Caso a partida seja gerada antes de todos os players entrarem, os que estão fora não conseguirão jogar aquela partida.
                <br>Então estipulamos colocar uma data prévia para os times estarem completos. Caso isso não ocorra e a partida seja gerada, é passível de punição e até W.O
              </dd>

              <dt>Como eu crio partidas entre os times?</dt>
              <dd>
                Na página de seu campeonato vá em Partidas e clique em "Criar partida".
                <br>Escolha os dois times (que deverão estar inscritos) e horário de início e clique em salvar.
                <br>A partida irá estar disponível apenas para os times 30 minutos antes do horário de início na página inicial do QUEOTA.club.
              </dd>

              <dt>Sobre as partidas criadas:</dt>
              <dd>
                Todas as partidas criadas, irão aparecer na aba “partidas” do campeonato. Caso alguma partida não aconteça, seja cancelada, tenha algum problema e não seja finalizada por pontuação padrão. O ADMIN poderá ir na aba campeonatos e excluir a partida.
                <br>A opção “remover” irá aparecer logo ao lado das partidas não finalizadas por pontuação normal.
              </dd>

              <dt>Onde aparecem as lobbies para os jogadores?</dt>
              <dd>
                Como já dito as partidas só serão liberadas 30 minutos antes do horário.
                <br>Na página inicial, logo abaixo do perfil do usuário, as partidas irão aparecer para os membros dos dois times.
              </dd>

              <dt>Como os jogadores irão para as lobbies?</dt>
              <dd>
                Nas partidas agendadas terá o nome do time A vs nome do time B, horário da partida e a opção “ir para a lobby”.
                <br>Clicando na opção “ir para a lobby”, o jogador será direcionado para a lobby da partida que terão os dois times, um chat e a opção “ready”.
              </dd>

              <dt>Como confirmar que os times estão prontos?</dt>
              <dd>
                Dentro da lobby, os players devem clicar no botão “ready”.
                <br>Há um marcador circular ao lado do nome de cada player, depois de confirmar, o marcador ficará VERDE. Isso confirmará que o jogador está ativo e pronto para ir para o servidor.
              </dd>

              <dt>O que acontece quando todos os jogadores derem “ready”?</dt>
              <dd>Se no mínimo 5 players de cada time confirmarem, será gerado o IP da partida.</dd>

              <dt>O que fazer dentro do servidor?</dt>
              <dd>Cada player que entrar dentro do servidor deve digitar “.ready”, esse comando irá confirmar o jogador como pronto para jogo. Depois que os 5 players de cada time digitarem, irá iniciar os vetos.</dd>

              <dt>Como funcionam os vetos?</dt>
              <dd>
                A opção de veto irá aparecer para um jogador aleatório de cada time. Quando o último mapa for escolhido, será trocado para o mapa vetado.
                <br>No mapa oficial do jogo, os jogadores devem novamente digitar “.ready”.
                <br>Quando 5 players de cada time confirmarem, a partida irá iniciar.
              </dd>
            </dl>
          </div>

          <h2>Não esclareceu sua dúvida aqui?</h2>
          <p>
            <router-link :to="{ name: 'ForumCreate' }">Crie um post em nosso Forum</router-link>- iremos responder o mais rápido possível.
          </p>

          <iframe
            src="https://discordapp.com/widget?id=341625098991566858&theme=dark"
            width="350"
            height="160"
            allowtransparency="true"
            frameborder="0"
          ></iframe> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass">
.support-page
  // background: #f1f1f1
  .toc-section
    margin-bottom: 50px

  .faq-section
    &:not(:last-child)
      border-bottom: 1px solid #ccc
      margin-bottom: 30px
      padding-bottom: 20px
    dt
      &:not(:first-child)
        margin-top: 30px
</style>


<script>
import Header from "@/components/Header";
export default {
  name: "Support",
  metaInfo: {
    title: "Suporte"
  },
  data() {
    return {};
  },
  methods: {
    initialize() {}
  },
  mounted() {
    this.initialize();
  },
  components: {
    Header
  }
};
</script>
